import { store } from './store';
import authActions from '@iso/redux/auth/actions';

export default () =>
  Promise.resolve()
